import React from 'react';
import ReactDOM from 'react-dom';

class CheckboxList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      checked: props.selected
    }

    this.onChangeValue = this.onChangeValue.bind(this);
  }

  onChangeValue(event) {
    var updatedList = [...this.state.checked];
    if (event.target.checked) {
      updatedList = [...this.state.checked, event.target.value];
    } else {
      updatedList.splice(this.state.checked.indexOf(event.target.value), 1);
    }
    this.setState({
      checked: updatedList
    });
    this.props.onChange(updatedList);
  }

  renderCheckbox(model) {
    
    var amIChecked = this.state.checked.includes(model.Name)

    var countStr = "";
    if (model.Count) {
      countStr = " (" + model.Count + ")";
    }
    return <div className={"form-group g-mb-0 " + (model.Disabled ? "u-has-disabled-v1" : "")} key={model.Name} >
        <input type="checkbox" defaultChecked={amIChecked} value={model.Name} disabled={model.Disabled} />
        <label className="ms-2" key={model.Name} title={model.Description} >
        
        {/* <div className="u-check-icon-checkbox-v4 g-absolute-centered--y g-left-0">
          <i className="fa fa-check" data-check-icon=""></i>
        </div> */}
        {model.Name}
        {countStr}

      </label>
    </div>;
  }
  render() {
    var options = this.props.options.map(function (obj, i) {
      return this.renderCheckbox(obj);
    }.bind(this));

    return (
      <div className="g-mb-40 " onChange={this.onChangeValue}>
        {options}
      </div>
    );
  }
}
export default CheckboxList;

